/** Legacy employer API host; OAuth must use services.* instead. */
export const FOUNTAIN_OAUTH_LEGACY_API_HOST = 'api.fountain.com';

/** Default services hire root when org settings still use the legacy API host. */
export const FOUNTAIN_OAUTH_SERVICES_HIRE_API_ROOT =
  'https://services.fountain.com/api/servicehire/v2';

/**
 * Maps legacy `api.fountain.com` OAuth misconfiguration to the services hire API root.
 * Call before validating the URL for OAuth install/test paths.
 */
export const resolveFountainOAuthHireApiBaseUrl = (
  hireApiBaseUrl: string,
): string => {
  const trimmed = hireApiBaseUrl.trim();
  try {
    const parsed = new URL(trimmed);
    if (parsed.hostname === FOUNTAIN_OAUTH_LEGACY_API_HOST) {
      return FOUNTAIN_OAUTH_SERVICES_HIRE_API_ROOT;
    }
  } catch {
    return trimmed;
  }
  return trimmed.replace(/\/$/, '');
};
